import axios from "../../interceptors/axiosInterceptor";
import {
  METRICS_CREATE_UPDATE_URL,
  METRICS_GET_ALL_CORE_URL,
  METRICS_DETAILS_URL,
  METRICS_FETCH_CATEGORY_LIST_FOR_CITY_URL,
  METRICS_UPLOAD_URL,
} from "../../config/Url";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import {
  ICreateUpdateMetrics,
  IGetQueryParams,
  IMultiSelectInterfaceSourceNormalizer,
} from "interfaces/Index";
import {
  normalizeCategoriesForMetrics,
  normalizeCoreMetrics,
  normalizeFetchMetricsDetails,
} from "normalizer/MetricsNormalizer";
import { SOMETHING_WENT_WRONG } from "config/constants";

export const createUpdateMetricsApiCall = (payload: ICreateUpdateMetrics) =>
  new Promise<void>((resolve, reject) => {
    axios
      .put(METRICS_CREATE_UPDATE_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchMetricsDetailsApiCall = (id: string) =>
  new Promise<ICreateUpdateMetrics>((resolve, reject) => {
    let url = METRICS_DETAILS_URL.replace("{cityId}", id);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          const normalizedRes: ICreateUpdateMetrics =
            normalizeFetchMetricsDetails(data);
          resolve(normalizedRes);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getAllCoreMetricsAPICall = (
  queryParam: IGetQueryParams = {}
): Promise<IMultiSelectInterfaceSourceNormalizer[]> => {
  return new Promise((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(METRICS_GET_ALL_CORE_URL, requestConfig)
      .then((response) => {
        if (response) {
          const newResponse = normalizeCoreMetrics(response.data);
          resolve(newResponse);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const getCategoriesForMetrics = (cityId: string) =>
  new Promise<any>((resolve, reject) => {
    const url = METRICS_FETCH_CATEGORY_LIST_FOR_CITY_URL.replace(
      "{cityId}",
      cityId
    );
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = normalizeCategoriesForMetrics(response.data);
          resolve(data);
        } else {
          reject({ errors: SOMETHING_WENT_WRONG });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const metricsCSVMultiPartUploadApiCall = (
  payload: FormData,
  queryParam: IGetQueryParams = {}
) =>
  new Promise<void>((resolve, reject) => {
    let requestConfig: any = getAuthOptions(true);
    requestConfig.params = queryParam;
    axios
      .post(METRICS_UPLOAD_URL, payload, requestConfig)
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
